import get from 'lodash/get';
import toString from 'lodash/toString';
import { fromJS } from 'immutable';
import { showErrorModal } from '../../redux/actions';
import { bugsnagNotify, bugsnagLeaveBreadcrumb } from '../../util/bugsnag';
import { filterSensitive } from '../../util';

export const defaultMessage =
  'Crash Reporter: An unexpected error occurred. If you continue to receive this error please contact the support.';

export const getMessage = (error, prefix = []) => {
  try {
    const message = get(error, 'message') || toString(error);
    return prefix.concat(message).join(' ');
  } catch (err) {
    return defaultMessage;
  }
};

const crashReporter =
  ({ getState }) =>
  (dispatch) =>
  (action) => {
    try {
      dispatch(action);
      bugsnagLeaveBreadcrumb(action.type, action);
    } catch (error) {
      const filteredAction = filterSensitive(action);
      const payload = get(filteredAction, 'data');
      const state = fromJS(getState()).toJS();
      const context = JSON.stringify({ filteredAction, state });
      bugsnagNotify(error, { metadata: { payload, context, state } });

      const message = getMessage(error, ['Reducer Error:']);
      const errorModalAction = showErrorModal(message);
      dispatch(errorModalAction);
    }
  };

export default crashReporter;
